import * as actionType from "./Action_Type";
import { CALL_API } from "../Middlewares/api";
import { CHANGE_PASSWORD, LANGUAGE_SET, LANGUAGE_GET } from "../Utils/Strings/Service_Endpoint";
import * as SGUri from "../Utils/PagesSwitch.js";
 
export const changePassword = (pswModel) => {
  var obj = {
    OldPassword : pswModel.oldPassword,
    NewPassword : pswModel.newPassword,
    ConfirmPassword : pswModel.confirmNewPassword
  };
  return {
    [CALL_API]: {
      endpoint: CHANGE_PASSWORD,
      authenticated: true,
      types: [
        actionType.SERVICE_CHANGEPASSWORD_REQUEST,
        actionType.SERVICE_CHANGEPASSWORD_SUCCESS,
        actionType.SERVICE_CHANGEPASSWORD_ERROR
      ],
      method : "POST",
      data   : SGUri.serializeParametersPOST(obj)
    }
  };
}

export const confirmDialogOpen = () =>{
    return dispatch =>{
        dispatch({type : actionType.SERVICE_CHANGEPASSWORD_OPENDIALOG})
    }
}

export const confirmDialogClose = () =>{
    return dispatch =>{
        dispatch({type : actionType.SERVICE_CHANGEPASSWORD_CLOSEDIALOG})
    }
}


export const getLanguageList = () => {
  return {
    [CALL_API]: {
      endpoint: LANGUAGE_GET,
      authenticated: true,
      types: [
        actionType.SERVICE_LANGUAGE_GET_REQUEST,
        actionType.SERVICE_LANGUAGE_GET_SUCCESS,
        actionType.SERVICE_LANGUAGE_GET_ERROR
      ]
    }
  };
}

export const setLanguage = (lang) => {
  var obj = {
    Key : lang
  }
  return {
    [CALL_API]: {
      endpoint: LANGUAGE_SET,
      authenticated: true,
      types: [
        actionType.SERVICE_LANGUAGE_SET_REQUEST,
        actionType.SERVICE_LANGUAGE_SET_SUCCESS,
        actionType.SERVICE_LANGUAGE_SET_ERROR
      ],
      method : "POST",
      data   : SGUri.serializeParametersPOST(obj)
    }
  };
}


// WEBPACK FOOTER //
// ./src/Actions/Action_ServiceRequest_Impostazioni.js